/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Toast_DeletedInputs */

const en_story_bank_toast_deleted = /** @type {(inputs: Story_Bank_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story deleted`)
};

const de_story_bank_toast_deleted = /** @type {(inputs: Story_Bank_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story deleted`)
};

const fr_story_bank_toast_deleted = /** @type {(inputs: Story_Bank_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story deleted`)
};

const es_story_bank_toast_deleted = /** @type {(inputs: Story_Bank_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story deleted`)
};

const it_story_bank_toast_deleted = /** @type {(inputs: Story_Bank_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story deleted`)
};

const nl_story_bank_toast_deleted = /** @type {(inputs: Story_Bank_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story deleted`)
};

const pl_story_bank_toast_deleted = /** @type {(inputs: Story_Bank_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story deleted`)
};

const fi_story_bank_toast_deleted = /** @type {(inputs: Story_Bank_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story deleted`)
};

const da_story_bank_toast_deleted = /** @type {(inputs: Story_Bank_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story deleted`)
};

const sv_story_bank_toast_deleted = /** @type {(inputs: Story_Bank_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story deleted`)
};

/**
* | output |
* | --- |
* | "Story deleted" |
*
* @param {Story_Bank_Toast_DeletedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_toast_deleted = /** @type {((inputs?: Story_Bank_Toast_DeletedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Toast_DeletedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_toast_deleted(inputs)
	if (locale === "fr") return fr_story_bank_toast_deleted(inputs)
	if (locale === "es") return es_story_bank_toast_deleted(inputs)
	if (locale === "it") return it_story_bank_toast_deleted(inputs)
	if (locale === "nl") return nl_story_bank_toast_deleted(inputs)
	if (locale === "pl") return pl_story_bank_toast_deleted(inputs)
	if (locale === "fi") return fi_story_bank_toast_deleted(inputs)
	if (locale === "da") return da_story_bank_toast_deleted(inputs)
	if (locale === "sv") return sv_story_bank_toast_deleted(inputs)
	return en_story_bank_toast_deleted(inputs)
});